import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { Container, Header, Segment, Grid, Card, Message, Divider, List, Progress, Step } from 'semantic-ui-react';
import '../Playbook.css';

class TrainingSummary extends Component {
    render() {
        return (
            <Container fluid className="playbook-container">
                <h1 className="ui icon center aligned header playbook-branded-header" style={{fontFamily: 'Montserrat', textTransform: 'uppercase', color: 'rgb(35, 37, 58)', fontWeight: 600, fontSize: '38px', marginBottom: '-9px'}}>
                    <i aria-hidden="true" className="icon">
                        <img src="/static/media/logo-icon.7bb8994723bbdcd674f1.png" alt="logo-icon" style={{height: '68px', marginBottom: '-15px'}} />
                    </i>
                    Onboarding/Training
                </h1>
                <div className="ui divider"></div>

                <Grid stackable>
                    <Grid.Row>
                        <Grid.Column width={16}>
                            <Segment className="playbook-content">
                                <Header as="h2" className="section-header">Sales Management Framework: Training Summary</Header>
                                
                                <p>
                                    By now, you have seen the Multiply Sales Management Framework and the lengthy content explaining how to train someone to tell your company's message the correct way. The purpose of this document is to serve as your "cheat sheet" as you start training and/or onboarding your sales team.
                                </p>

                                <Divider />

                                <Header as="h2" className="section-header">Onboarding/Training Process</Header>
                                
                                <p>
                                    When thinking about onboarding a new salesperson, we prescribe an eight-week process. The process involves utilizing the Multiply Application to review the messaging and schedule reviews with your salesperson. The salesperson must be able to carry the message in four (4) scenarios. Those include:
                                </p>

                                <List bulleted>
                                    <List.Item>Boardroom setting</List.Item>
                                    <List.Item>Casual encounter (coffee, lunch, drinks, etc.)</List.Item>
                                    <List.Item>Phone call or short encounter (the Elevator Pitch)</List.Item>
                                    <List.Item>Video conference</List.Item>
                                </List>

                                <p>
                                    In each of these settings, the salesperson will draw on the same message but will use different levels of detail depending on the setting.
                                </p>

                                <p>
                                    By utilizing the following process, the sales team member can be capable of carrying the message comfortably in eight (8) weeks. The process is as follows:
                                </p>

                                <Divider />

                                <Header as="h3">Week 1: The First Review</Header>
                                <List bulleted>
                                    <List.Item>Explain the review process and the point of it, as well as the overall process of building a consistent message and the capabilities to carry the messaging to the market.</List.Item>
                                    <List.Item>Sales leadership (or a Multiply consultant) presents the story as a model.</List.Item>
                                    <List.Item><strong>Goal:</strong> Sales team understands the concepts and application of the messaging concepts.</List.Item>
                                    <List.Item><strong>Goal:</strong> Sales team members begin learning and practicing the messaging on their own.</List.Item>
                                </List>

                                <Header as="h3">Weeks 2-5: Initial Reviews</Header>
                                <List bulleted>
                                    <List.Item>Conduct at least 8 reviews with team members (2 of each setting).</List.Item>
                                    <List.Item><strong>Goal:</strong> Begin building comfort in constructing the messaging and controlling a meeting.</List.Item>
                                </List>

                                <Header as="h3">Weeks 5-8: The Final Preparation</Header>
                                <List bulleted>
                                    <List.Item>Simulate eight (8) real-world encounters as closely as possible, including distractions and strong objections.</List.Item>
                                    <List.Item>Demonstrate capabilities to talk through offerings.</List.Item>
                                    <List.Item><strong>Goal:</strong> Know how to apply—and have the capabilities to apply—the messaging in the four (4) settings.</List.Item>
                                    <List.Item><strong>Goal:</strong> Know how to execute and control a meeting starting with introductions, moving to messaging and asks, and ending with follow-ups.</List.Item>
                                </List>

                                <Header as="h3">Week 8: Final Assessment</Header>
                                <List bulleted>
                                    <List.Item>Final review of all four (4) messaging scenarios</List.Item>
                                    <List.Item>Independent client meeting simulation</List.Item>
                                    <List.Item>Receive final "green" assessment status</List.Item>
                                    <List.Item>Begin independent customer meetings with ongoing mentorship support</List.Item>
                                </List>

                                <Divider />

                                <Header as="h2" className="section-header">Success Metrics</Header>
                                
                                <p>
                                    Throughout the eight-week process, track progress using consistent assessment criteria. Each salesperson should demonstrate competency in messaging clarity, meeting control, and professional presentation across all four scenarios before moving to independent client interactions.
                                </p>

                                <Message info>
                                    <Message.Header>Training Best Practice</Message.Header>
                                    <p>
                                        Remember that consistency in training delivery and assessment ensures predictable results. 
                                        The framework works when applied systematically across your entire sales organization.
                                    </p>
                                </Message>

                            </Segment>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </Container>
        );
    }
}

export default observer(TrainingSummary);